/**
 * Detect whether the admin UI is running against a local/dev host.
 * Prefer browser hostname; fall back to API base URL when hostname is ambiguous.
 */
export function isLocalEnvironment() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === '0.0.0.0' ||
      host.endsWith('.local')
    ) {
      return true;
    }
    // Known production / preview hosts → not local
    if (
      host === 'cardxacademia.com' ||
      host === 'www.cardxacademia.com' ||
      host.endsWith('.vercel.app')
    ) {
      return false;
    }
  }

  const apiUrl = (
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    ''
  ).toLowerCase();

  if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) {
    return true;
  }
  if (apiUrl.includes('cardxacademia.onrender.com') || apiUrl.includes('cardxacademia.com')) {
    return false;
  }

  // Default: treat unknown hosts as production-safe (don't falsely show Local)
  return false;
}

export const STATUS_STYLES = {
  pending: 'bg-amber-50 text-amber-800 border-amber-200',
  confirmed: 'bg-brand-blue-50 text-brand-blue-700 border-brand-blue-200',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cancelled: 'bg-red-50 text-red-700 border-red-200',
  replied: 'bg-brand-gold-50 text-brand-gold-800 border-brand-gold-200',
  unread: 'bg-brand-blue-50 text-brand-blue-700 border-brand-blue-200',
  read: 'bg-gray-100 text-gray-600 border-gray-200',
  submitted: 'bg-brand-sky-100 text-brand-sky-800 border-brand-sky-200',
};

export function StatusBadge({ status }) {
  const style = STATUS_STYLES[status] || 'bg-gray-100 text-gray-600 border-gray-200';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border capitalize ${style}`}>
      {status || 'unknown'}
    </span>
  );
}

export function formatDateTime(iso) {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}

export function formatDate(value) {
  if (!value) return '-';
  try {
    const d = typeof value === 'string' && value.length <= 10
      ? new Date(`${value}T12:00:00`)
      : new Date(value);
    return d.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return String(value);
  }
}

export function serviceLabel(value) {
  if (!value) return '-';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}
